import React, { memo } from 'react'
import { TextareaStyle, TextareaWrapperStyle, Error } from './style'

const Textarea = ({ error, className, register, rightInfo, ...props }) => {
	return (
		<TextareaWrapperStyle className={className}>
			<TextareaStyle ref={register} error={error} {...props} />
			{error && <Error>{error?.message}</Error>}
		</TextareaWrapperStyle>
	)
}

export default memo(Textarea)
